import React, { Component } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import NgGameRPGArena from './arena';
import NggAllEngine from './engine/all';
import { FpsView } from "react-fps";
import { GoSnow } from '../snowfall3d';

import './style.css';

class NgGameRPG extends Component {

    arenaRef = React.createRef();
    uiRef = null;
    thinkTimeRef = null;

    allEngine = null;

    state = {
        caveLoading: false,
        settings: {
            cicleTime: 70,
            disableBackMove: false,
            miniBack: false,
            noSnow: false
        }
    }

    abandoneCave = (props) => {
        this.props.abandoneCave && this.props.abandoneCave(props);
    }

    startGame = () => {
        const res = this.preloadAllEngines();
        if (res) {
            this.loadCaveSession();
        }
    }

    componentDidMount = () => {
        const { caveId } = this.props;
        if (caveId) {
            this.startGame();
        }
    }

    componentDidUpdate = ({ iamuser }) => {
        // что то поменялось в экспе snowman
        if (iamuser && this.props.iamuser && this.allEngine) {
            //сравнниваем ресурсы экспы
            let prevExp = 0;
            let nowExp = 0;
            if (iamuser.myResourses.Scores && iamuser.myResourses.Scores.snowman)
                prevExp = iamuser.myResourses.Scores.snowman.all;

            if (this.props.iamuser.myResourses.Scores && this.props.iamuser.myResourses.Scores.snowman)
                nowExp = this.props.iamuser.myResourses.Scores.snowman.all;

            if (prevExp !== nowExp) {
                this.allEngine.setExp(nowExp);
            }
        }

    }

    preloadAllEngines = () => {
        this.allEngine = null;

        const { settings } = this.state;
        const { renewResourses } = this.props;

        console.log('NgGameRPG ### Проверяю ref Арены');
        if (!this.arenaRef || !this.arenaRef.current) {
            console.log('NgGameRPG ### ОШИБКА ref Арены');
            return false;
        }
        console.log('NgGameRPG ### ref Арены подключен');

        console.log('NgGameRPG ### Проверяю ref UI');
        if (!this.arenaRef.current.getUiRef) {
            console.log('NgGameRPG ### ОШИБКА ref UI');
            return false;
        }
        if (!this.arenaRef.current.getThinkTimeRef) {
            console.log('NgGameRPG ### ОШИБКА ref TIME THINK');
            return false;
        }
        console.log('NgGameRPG ### ref UI подключен');
        this.uiRef = this.arenaRef.current.getUiRef;
        this.thinkTimeRef = this.arenaRef.current.getThinkTimeRef;


        console.log('NgGameRPG ### создаю ALL ENGINE');

        this.allEngine = new NggAllEngine({ settings, renewResourses, abandoneCave: this.abandoneCave });
        this.allEngine.setGraphArena(this.arenaRef.current);
        this.allEngine.setUi(this.uiRef)
        this.allEngine.setTimeThink(this.thinkTimeRef)

        console.log('NgGameRPG ### ALL ENGINE создан');

        return true;

    }

    // это по сути старт игры непосредственный
    loadCaveSession = async () => {

        const { iamuser } = this.props;
        if (!iamuser || !this.allEngine) return;

        const { client, caveId } = this.props;

        this.allEngine.loadCave({ client, iamuser, CaveId: caveId });
        this.setState({ caveLoading: true });
    }

    render() {
        const { isMobile, iamuser, heightDirect } = this.props;
        const height = heightDirect || (isMobile ? 300 : 650);

        const { settings } = this.state;

        if (!iamuser) return <div>НЕТ ЮЗЕРА</div>

        return <div>
            <FpsView />
            <NgGameRPGArena ref={this.arenaRef} settings={settings} height={height} />
        </div>
    }

}


export default withCapoeiraSportState('client, isMobile, iamuser, renewResourses')(NgGameRPG);